module.exports = __webpack_public_path__ + "img/VotoPropuesta.232a0ba6.png";